import React from "react";
import coupleImg from "../../Assets/review/db2.jpg";
import heading from "../../Assets/SignUp/heading.png";
import bg from "../../Assets/SignUp/bg.png";
import absolute from "../../Assets/SignUp/absolute.png";
import { FaArrowLeftLong } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import useTitle from "../../Hooks/useTitle";

const PasswordReset = () => {
    useTitle('Reset Password')
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen md:h-screen overflow-hidden">
            {/* Left Side Image */}
            <div className="hidden md:flex relative justify-center items-center p-4 md:h-full">
                <div className="w-full h-full relative">
                    <img
                        src={coupleImg}
                        alt="Couple"
                        className="w-full h-full object-cover rounded-xl"
                    />
                    {/* Overlay Content */}
                    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
                        <img src={absolute} alt="Decorative Icon" className="mx-auto mb-2" />
                        <h1 className="text-lg md:text-xl lg:text-2xl font-bold">Add USA</h1>
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold">Gujarati Community</h2>
                    </div>
                </div>
            </div>

            {/* Right Side Form */}
            <div
                className="flex items-center justify-center min-h-screen md:h-full p-4 md:p-8"
                style={{
                    backgroundImage: `url(${bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="max-w-md w-full bg-white p-6 md:p-8 rounded-lg">
                    <div className="flex justify-center">
                        <img src={heading} alt="Matrimony" className="h-12 w-32" />
                    </div>
                    <h2 className="text-center text-xl font-semibold mt-2">Password Reset</h2>
                    <h3 className="text-center text-md text-gray-500 mt-2">Your password has been successfully reset.</h3>
                    <form className="flex flex-col">
                        <NavLink
                            to='/signin'
                            className="w-full bg-[#E72848] text-white text-center p-3 my-4 rounded-xl font-semibold hover:bg-[#f53b58] transition duration-300 cursor-pointer">
                            Continue
                        </NavLink>

                        <div className="text-center flex justify-center gap-2 text-gray-600">
                            <FaArrowLeftLong size={22} />
                            <NavLink to='/signin' className="text-md text-[#535861] font-medium">Back to Log in</NavLink>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PasswordReset;
